import "./App.css";
import AppLayout from "./layouts/AppLayout.tsx";
import Factory from "./pages/factory/Factory.tsx";
import { WagmiProvider } from "wagmi";
import { config } from "./wagmi.config.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ConnectGuard from "./guards/ConnectGuard.tsx";
import { BrowserRouter, Route, Routes } from "react-router";
import TokenWhitelist from "./pages/factory/TokenWhitelist.tsx";
import CreateEscrow from "./pages/factory/CreateEscrow.tsx";
import EscrowList from "./pages/escrow-list/EscrowList.tsx";
import EscrowWrapper from "./pages/escrow/EscrowWrapper.tsx";
import Nicknames from "./pages/factory/Nicknames.tsx";
import DesktopOnlyGuard from "./guards/DesktopOnlyGuard.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
      <BrowserRouter>
        <WagmiProvider config={config}>
          <QueryClientProvider client={queryClient}>
              <DesktopOnlyGuard>
                <ConnectGuard>
                  <AppLayout>
                    <Routes>
                      <Route path="/" element={<EscrowList />} />
                      <Route path="/escrow/:address" element={<EscrowWrapper />} />
                      <Route path="/factory" element={<Factory />} />
                      <Route
                        path="/factory/whitelist"
                        element={<TokenWhitelist />}
                      />
                      <Route
                        path="/factory/new-escrow"
                        element={<CreateEscrow />}
                      />
                      <Route path="/factory/nicknames" element={<Nicknames />} />
                    </Routes>
                  </AppLayout>
                </ConnectGuard>
              </DesktopOnlyGuard>
          </QueryClientProvider>
        </WagmiProvider>
      </BrowserRouter>
  );
}
